import _extends from "@babel/runtime/helpers/esm/extends";

/* eslint-disable import/order */
// This file has been generated using @svgr/cli.
// Run "yarn generate:icons" in order to generate the files for new icons.
import * as React from 'react';
import styled from 'styled-components';
import { size, color } from 'styled-system';

var SvgComponent = function SvgComponent(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.824 35.68a1.753 1.753 0 0 1-2.112 1.272 1.738 1.738 0 0 1-1.305-1.335l-4.404-21.893-4.427 18.505a1.75 1.75 0 0 1-2.102 1.286 1.742 1.742 0 0 1-1.298-1.256l-3.541-14.206-2.269 6.054A2.623 2.623 0 0 1 7.9 25.81H3.875A.869.869 0 0 1 3 24.947c0-.476.392-.862.875-.862h4.024a.876.876 0 0 0 .824-.57l2.267-6.05a1.74 1.74 0 0 1 1.204-1.08c.935-.24 1.89.313 2.137 1.246l3.541 14.205L22.3 13.332a1.738 1.738 0 0 1 1.352-1.296 1.75 1.75 0 0 1 2.067 1.347l4.404 21.892 3.56-15.919c.127-.52.493-.954.99-1.171.884-.387 1.918.005 2.297.848l2.244 4.54c.14.312.453.512.8.512h4.112c.483 0 .875.386.875.862a.869.869 0 0 1-.875.862h-4.113c-1.037 0-1.977-.602-2.386-1.508l-2.243-4.54-3.56 15.918Z",
    fill: "currentColor"
  }));
};

var SvgSoundwave = styled(SvgComponent).withConfig({
  displayName: "Soundwave__SvgSoundwave",
  componentId: "sc-1mcw3ur-0"
})(["", " ", ""], size, color);
export default SvgSoundwave;